/* tslint:disable */
/* eslint-disable */
/**
 * User Config Service API
 * Server-side storage for OpenField client configuration: the UI state that currently lives in the browser\'s `localStorage` (effort colours, saved report items, recent colours, panel sort order, ...), so it survives a cache clear and follows a user between browsers and devices.  **SCAFFOLDING:** the `/settings` resource below is a placeholder CRUD surface used to stand the service up end to end. The real key namespaces, value shapes and any per-key schema are still to be designed. See \"Open decisions\" in AGENTS.md.  **Model:** a setting is an opaque JSON value stored under a string key, scoped to the caller\'s account. Values are stored and returned verbatim; the service does not interpret them.  **Identity:** the caller\'s account comes from the gateway-verified JWT. Config is currently scoped to the account only. The shared JWT authorizer does not yet emit a user identity, so per-user scoping is an open decision (see AGENTS.md). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Region of the account
 * @export
 * @enum {string}
 */

export const AccountRegion = {
    Eu: 'EU',
    Us: 'US',
    Au: 'AU',
    Cn: 'CN'
} as const;

export type AccountRegion = typeof AccountRegion[keyof typeof AccountRegion];


/**
 * 
 * @export
 * @interface BaseErrorResponse
 */
export interface BaseErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof BaseErrorResponse
     */
    'request_id': string;
    /**
     * 
     * @type {string}
     * @memberof BaseErrorResponse
     */
    'reason': string;
    /**
     * Optional list of field-specific errors
     * @type {Array<BaseErrorResponseFields>}
     * @memberof BaseErrorResponse
     */
    'fields'?: Array<BaseErrorResponseFields>;
}
/**
 * 
 * @export
 * @interface BaseErrorResponseFields
 */
export interface BaseErrorResponseFields {
    /**
     * The name of the field that caused the error
     * @type {string}
     * @memberof BaseErrorResponseFields
     */
    'field'?: string;
    /**
     * A description of the error related to the field
     * @type {string}
     * @memberof BaseErrorResponseFields
     */
    'message'?: string;
}
/**
 * Body for a setting write.  Business rules (422 when violated): the serialised `value` must not exceed the service\'s maximum setting size. 
 * @export
 * @interface RequestSaveSetting
 */
export interface RequestSaveSetting {
    /**
     * The stored value. Any JSON value is accepted (object, array, string, number, boolean or null) and is round-tripped verbatim; the service does not interpret it. 
     * @type {any}
     * @memberof RequestSaveSetting
     */
    'value': any;
}
/**
 * A single stored setting.
 * @export
 * @interface Setting
 */
export interface Setting {
    /**
     * Key the value is stored under
     * @type {string}
     * @memberof Setting
     */
    'key': string;
    /**
     * The stored value. Any JSON value is accepted (object, array, string, number, boolean or null) and is round-tripped verbatim; the service does not interpret it. 
     * @type {any}
     * @memberof Setting
     */
    'value': any;
    /**
     * Creation date and time of the setting
     * @type {string}
     * @memberof Setting
     */
    'created_at': string;
    /**
     * Last modification date and time of the setting
     * @type {string}
     * @memberof Setting
     */
    'modified_at': string;
}

/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * Health check
         * @summary Health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * Health check
     * @summary Health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthCheck(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove the setting, returning the client to its built-in default for that key.
         * @summary Delete a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSetting: async (settingKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settingKey' is not null or undefined
            assertParamExists('deleteSetting', 'settingKey', settingKey)
            const localVarPath = `/settings/{setting_key}`
                .replace(`{${"setting_key"}}`, encodeURIComponent(String(settingKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single setting by key.
         * @summary Get a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetting: async (settingKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settingKey' is not null or undefined
            assertParamExists('getSetting', 'settingKey', settingKey)
            const localVarPath = `/settings/{setting_key}`
                .replace(`{${"setting_key"}}`, encodeURIComponent(String(settingKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve every setting stored for the authenticated account, ordered by key. Intended for the client to hydrate its state in one request on app load. 
         * @summary List settings
         * @param {string} [keyPrefix] Only return settings whose key starts with this prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (keyPrefix?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (keyPrefix !== undefined) {
                localVarQueryParameter['key_prefix'] = keyPrefix;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write the setting under this key, replacing any existing value. The call is idempotent: repeating it with the same body is a no-op beyond `modified_at`. 
         * @summary Create or replace a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {RequestSaveSetting} requestSaveSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSetting: async (settingKey: string, requestSaveSetting: RequestSaveSetting, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settingKey' is not null or undefined
            assertParamExists('putSetting', 'settingKey', settingKey)
            // verify required parameter 'requestSaveSetting' is not null or undefined
            assertParamExists('putSetting', 'requestSaveSetting', requestSaveSetting)
            const localVarPath = `/settings/{setting_key}`
                .replace(`{${"setting_key"}}`, encodeURIComponent(String(settingKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSaveSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove the setting, returning the client to its built-in default for that key.
         * @summary Delete a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSetting(settingKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSetting(settingKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a single setting by key.
         * @summary Get a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSetting(settingKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Setting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSetting(settingKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve every setting stored for the authenticated account, ordered by key. Intended for the client to hydrate its state in one request on app load. 
         * @summary List settings
         * @param {string} [keyPrefix] Only return settings whose key starts with this prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(keyPrefix?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Setting>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettings(keyPrefix, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Write the setting under this key, replacing any existing value. The call is idempotent: repeating it with the same body is a no-op beyond `modified_at`. 
         * @summary Create or replace a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {RequestSaveSetting} requestSaveSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSetting(settingKey: string, requestSaveSetting: RequestSaveSetting, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Setting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSetting(settingKey, requestSaveSetting, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * Remove the setting, returning the client to its built-in default for that key.
         * @summary Delete a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSetting(settingKey: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSetting(settingKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single setting by key.
         * @summary Get a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetting(settingKey: string, options?: any): AxiosPromise<Setting> {
            return localVarFp.getSetting(settingKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve every setting stored for the authenticated account, ordered by key. Intended for the client to hydrate its state in one request on app load. 
         * @summary List settings
         * @param {string} [keyPrefix] Only return settings whose key starts with this prefix
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(keyPrefix?: string, options?: any): AxiosPromise<Array<Setting>> {
            return localVarFp.getSettings(keyPrefix, options).then((request) => request(axios, basePath));
        },
        /**
         * Write the setting under this key, replacing any existing value. The call is idempotent: repeating it with the same body is a no-op beyond `modified_at`. 
         * @summary Create or replace a setting
         * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
         * @param {RequestSaveSetting} requestSaveSetting 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSetting(settingKey: string, requestSaveSetting: RequestSaveSetting, options?: any): AxiosPromise<Setting> {
            return localVarFp.putSetting(settingKey, requestSaveSetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * Remove the setting, returning the client to its built-in default for that key.
     * @summary Delete a setting
     * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteSetting(settingKey: string, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteSetting(settingKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a single setting by key.
     * @summary Get a setting
     * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getSetting(settingKey: string, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getSetting(settingKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve every setting stored for the authenticated account, ordered by key. Intended for the client to hydrate its state in one request on app load. 
     * @summary List settings
     * @param {string} [keyPrefix] Only return settings whose key starts with this prefix
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getSettings(keyPrefix?: string, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getSettings(keyPrefix, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write the setting under this key, replacing any existing value. The call is idempotent: repeating it with the same body is a no-op beyond `modified_at`. 
     * @summary Create or replace a setting
     * @param {string} settingKey Client-chosen key the value is stored under. Dot-separated namespacing is encouraged (e.g. &#x60;report.effort-colors&#x60;) so related keys can be fetched with &#x60;key_prefix&#x60;. 
     * @param {RequestSaveSetting} requestSaveSetting 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public putSetting(settingKey: string, requestSaveSetting: RequestSaveSetting, options?: AxiosRequestConfig) {
        return SettingsApiFp(this.configuration).putSetting(settingKey, requestSaveSetting, options).then((request) => request(this.axios, this.basePath));
    }
}


